import { Button, Chip } from '@mui/material';
import React, { Fragment, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { MANUAL_BATCH_MAX_ORDERS } from 'constants/order.constants';
import { TranslationNamespace } from 'i18n';

type Props = {
  selectedCount: number;
  onAssign: () => void;
  onCancel: () => void;
  onClear: () => void;
};

export const ManualOrdersToolbar: React.FC<Props> = ({
  selectedCount,
  onAssign,
  onCancel,
  onClear,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.manual',
  });

  const isOverLimit = useMemo(
    () => selectedCount > MANUAL_BATCH_MAX_ORDERS,
    [selectedCount],
  );

  const actionsDisabled = useMemo(
    () => !selectedCount || isOverLimit,
    [selectedCount, isOverLimit],
  );

  const handleClear = useCallback(() => onClear(), [onClear]);

  return (
    <div className="tw-flex tw-items-center tw-gap-3 tw-py-3">
      <Chip
        color={isOverLimit ? 'error' : 'default'}
        label={t('selected', {
          count: selectedCount,
          max: MANUAL_BATCH_MAX_ORDERS,
        })}
      />
      {isOverLimit && (
        <span className="tw-text-red-500">
          {t('limit_exceeded', { max: MANUAL_BATCH_MAX_ORDERS })}
        </span>
      )}
      <div className="tw-flex-1" />
      {!!selectedCount && (
        <Fragment>
          <Button size="small" onClick={handleClear}>
            {t('clear_selection')}
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="error"
            disabled={actionsDisabled}
            onClick={onCancel}
          >
            {t('cancel_orders')}
          </Button>
        </Fragment>
      )}
      <Button
        size="small"
        variant="contained"
        disabled={actionsDisabled}
        onClick={onAssign}
      >
        {t('assign_provider')}
      </Button>
    </div>
  );
};
